export const GNB = {
  DESKTOP: {
    WIDTH: 200,
  },
  MOBILE: {
    HEIGHT: 60,
  },
} as const;
export const FOOTER = {
  DESKTOP: {
    HEIGHT: 0,
  },
  MOBILE: {
    HEIGHT: 0,
  },
} as const;
